import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ClinicPage from './ClinicPage.js';

export default WithGASetup(ClinicPage, AuthContext);
